import AutoSourcingRule from 'entities/autoSourcingRule/model';

export const INIT = 'app/AutoSourcingPage/INIT';
export const INIT_FAILED = 'app/AutoSourcingPage/INIT_FAILED';
export const INIT_SUCCESS = 'app/AutoSourcingPage/INIT_SUCCESS';

export const SUBMIT = 'app/AutoSourcingPage/SUBMIT';
export const SUBMIT_FAILED = 'app/AutoSourcingPage/SUBMIT_FAILED';
export const SUBMIT_SUCCESS = 'app/AutoSourcingPage/SUBMIT_SUCCESS';

export interface InitAction {
  type: typeof INIT;
}
export const initAction = (): InitAction => ({
  type: INIT,
});

export const initSuccessAction = () => ({
  type: INIT_SUCCESS,
});

export const initFailedAction = () => ({
  type: INIT_FAILED,
});

export interface SubmitAction {
  type: typeof SUBMIT;
  data: AutoSourcingRule | { locations: string[]; categories: string[]; providers: string[] };
}
export const submitAction = (
  data: AutoSourcingRule | { locations: string[]; categories: string[]; providers: string[] }
): SubmitAction => ({
  type: SUBMIT,
  data,
});

export const submitSuccessAction = () => ({
  type: SUBMIT_SUCCESS,
});

export const submitFailedAction = () => ({
  type: SUBMIT_FAILED,
});
